import { render, staticRenderFns } from "./Caracteristica.vue?vue&type=template&id=86b354f8&scoped=true"
import script from "./Caracteristica.vue?vue&type=script&lang=js"
export * from "./Caracteristica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b354f8",
  null
  
)

export default component.exports